import { price as priceUtil } from '@eti/utils';
import { css } from '@eti/styles';
import { productIds } from '@eti/products';
import { useSiteContext, useTranslation } from '@eti/providers';
import { ScreenReaderPrice } from '@eti/components';
import { CartRow, Price } from '../../../../widgets/cart/components/CartComponents';
import type { PreSelectedExtraProducts } from '../../models';

const wrapperStyles = css`
  &:not(:last-child) {
    margin-bottom: 16px;
  }
`;

const headerFooterStyles = css`
  font-weight: 700;
`;

interface PriceBreakdownPreSelectedProductsProps {
  preSelectedExtraProducts: PreSelectedExtraProducts[];
}

const PriceBreakdownPreSelectedProducts = ({
  preSelectedExtraProducts,
}: PriceBreakdownPreSelectedProductsProps) => {
  const { t } = useTranslation();
  const { partner } = useSiteContext();

  const descriptionText =
    t(`SelectedTrip.PreSelectedProducts.Header.${partner}`) ||
    t('SelectedTrip.PreSelectedProducts.Header.NoPartner');

  return (
    <div className={wrapperStyles}>
      <CartRow className={headerFooterStyles}>
        <span>{descriptionText}</span>
      </CartRow>

      {preSelectedExtraProducts.map(({ productId, name, totalPrice }) => {
        const formattedTotalPrice = priceUtil.formatPrice(totalPrice);

        return (
          <CartRow
            data-testid={`priceBreakdown-preSelectedProduct-${productIds[productId]}`}
            key={productId}
          >
            <span data-testid={`priceBreakdown-preSelectedProduct-${productIds[productId]}-title`}>
              {name}
            </span>
            <Price
              aria-hidden
              data-testid={`priceBreakdown-preSelectedProduct-${productIds[productId]}-price`}
            >
              {formattedTotalPrice}
            </Price>
            <ScreenReaderPrice price={formattedTotalPrice} />
          </CartRow>
        );
      })}
    </div>
  );
};

export default PriceBreakdownPreSelectedProducts;
